import { z } from "zod";
import {
  PDC_AMOUNT,
  PDC_AMOUNT_RECEIVED,
  PDC_CLEARED_DATE,
  PDC_DATE,
  PDC_NO,
  PDC_REMARKS,
  PDC_STATUS,
  YEAR
} from "./consts";

export const schema = z.object({
  [YEAR]: z.string().min(1, "This field is required"),
  [PDC_NO]: z.string().min(6, "This field must be 6 digits"),
  [PDC_AMOUNT]: z.string().min(1, "This field is required"),
  [PDC_DATE]: z.string().min(1, "This field is required"),
  [PDC_AMOUNT_RECEIVED]: z.string().optional(),
  [PDC_STATUS]: z.string().min(1, "This field is required"),
  [PDC_CLEARED_DATE]: z.string().optional(),
  [PDC_REMARKS]: z.string().min(1, "This field is required"),
});

export type formValues = z.infer<typeof schema>;
